import { MDButton } from "components/MDButton";
import { FilterCursesContainer, FilterCursesContentPopUp, FilterCursesLabel } from "./styles";
import { Checkbox, Icon, List } from "@mui/material";
import { useEffect, useRef, useState } from "react";
const FilterCursesForTable = ({ filters, stateFilters, handleCheckbox }: any) => {
  const [exibition, setExibition] = useState(false);
  const popupRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setExibition(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <FilterCursesContainer>
      <MDButton variant="outlined" color="dark" onClick={() => setExibition((prev) => !prev)}>
        filters&nbsp;
        <Icon>keyboard_arrow_down</Icon>
      </MDButton>
      <FilterCursesContentPopUp ref={popupRef} exibition={exibition}>
        {[
          {
            title: "Categorias",
            content: (
              <List inlist={true} sx={{ flexDirection: "column", display: "flex" }}>
                {filters?.subcategories?.map((item: any) => (
                  <FilterCursesLabel key={item.slug}>
                    <Checkbox
                      checked={!!stateFilters?.categoriesSlugs?.[item?.slug]}
                      onChange={(evt) => {
                        handleCheckbox(evt, "categoriesSlugs");
                      }}
                      value={item.slug}
                    />

                    {item.name}
                  </FilterCursesLabel>
                ))}
              </List>
            ),
            hide: !filters?.subcategories?.length,
          },
          {
            title: "Modalidade",
            content: (
              <List inlist={true} sx={{ flexDirection: "column", display: "flex" }}>
                {filters?.modalities?.map((modality: any) => (
                  <FilterCursesLabel key={modality.id}>
                    <Checkbox
                      checked={!!stateFilters?.modalitiesNames?.[modality?.name]}
                      onChange={(evt) => {
                        handleCheckbox(evt, "modalitiesNames");
                      }}
                      value={modality.name}
                    />
                    {modality.name}
                  </FilterCursesLabel>
                ))}
              </List>
            ),
            hide: !filters?.modalities?.length,
          },
          {
            title: "Área de interesse",
            content: (
              <List inlist={true} sx={{ flexDirection: "column", display: "flex" }}>
                {filters?.teachingAreas?.map((item: any) => (
                  <FilterCursesLabel key={item.id}>
                    <Checkbox
                      checked={!!stateFilters?.teachingAreaNames?.[item?.name]}
                      onChange={(evt) => handleCheckbox(evt, "teachingAreaNames")}
                      value={item.name}
                    />
                    {item.name}
                  </FilterCursesLabel>
                ))}
              </List>
            ),
            hide: !filters?.teachingAreas?.length,
          },
          {
            title: "Unidade",
            content: (
              <List inlist={true} sx={{ flexDirection: "column", display: "flex" }}>
                {filters?.educationalUnits?.map((unit: any) => (
                  <FilterCursesLabel key={unit.id}>
                    <Checkbox
                      checked={!!stateFilters?.educationalUnitNames?.[unit?.visibleName]}
                      onChange={(evt) => handleCheckbox(evt, "educationalUnitNames")}
                      value={unit.visibleName}
                    />
                    {unit.visibleName}, {unit.state}
                  </FilterCursesLabel>
                ))}
              </List>
            ),
            hide: !filters?.educationalUnits?.length,
          },
          {
            title: "Parceiros",
            content: (
              <List inlist={true} sx={{ flexDirection: "column", display: "flex" }}>
                {filters?.partners?.map((item: any) => (
                  <FilterCursesLabel key={item.id}>
                    <Checkbox
                      checked={!!stateFilters?.partnerVisibleNames?.[item?.visibleName]}
                      onChange={(evt) => handleCheckbox(evt, "partnerVisibleNames")}
                      value={item.visibleName}
                    />
                    {item.visibleName}
                  </FilterCursesLabel>
                ))}
              </List>
            ),
            hide: !filters?.partners?.length,
          },
          {
            title: "Estado",
            content: (
              <List inlist={true} sx={{ flexDirection: "column", display: "flex" }}>
                {filters?.states?.map((state: any, index: any) => (
                  <FilterCursesLabel key={index}>
                    <Checkbox
                      checked={!!stateFilters?.states?.[state]}
                      onChange={(evt) => handleCheckbox(evt, "states")}
                      value={state}
                    />
                    {state}
                  </FilterCursesLabel>
                ))}
              </List>
            ),
            hide: !filters?.states?.length,
          },
        ].map(
          (item, index) =>
            !item.hide && (
              <div key={index}>
                <div>{item.title}</div>
                <div>{item.content}</div>
              </div>
            )
        )}
      </FilterCursesContentPopUp>
    </FilterCursesContainer>
  );
};

export default FilterCursesForTable;
